export enum ManagerLeadsFilter {
  from = 'filters[lead][created_at][from]',
  to = 'filters[lead][created_at][to]',
  contractorIdArray = 'filters[contractor][id][]',
  serviceIdArray = 'filters[service][id][]',
  campaignsIdArray = 'filters[campaign][id][]',
}

export enum ManagerLeadsSort {
  campaignName = 'sort[campaign][name]',
  contractor = 'sort[contractor][company_name]',
  dateCreated = 'sort[lead][created_at]',
  fullName = 'sort[lead][full_name]',
  phoneNumber = 'sort[lead][phone_number]',
  email = 'sort[lead][email]',
  id = 'sort[lead][id]',
  price = 'sort[lead_billing_data][price]',
  service = 'sort[service][name]',
}
export enum ContractorLeadsFilter {
  from = 'filters[lead][created_at][from]',
  to = 'filters[lead][created_at][to]',
  campaignId = 'filters[campaign][id]',
  campaignIdArray = 'filters[campaign][id][]',
  serviceId = 'filters[service][id]',
  serviceIdArray = 'filters[service][id][]',
}

export enum ContractorLeadsSort {
  dateCreated = 'sort[lead][created_at]',
  fullName = 'sort[lead][full_name]',
  service = 'sort[service][name]',
  campaignName = 'sort[campaign][name]',
  email = 'sort[lead][email]',
  phone = 'sort[lead][phone_number]',
  cost = 'sort[lead_billing_data][price]',
}
